import auth from '@/firebase/auth'
import store from '../store'
import NProgress from 'nprogress'

var Acl = function () {
    var self = this

    self.next = null
    self.started = null
    self.teste = null

    self.startAcl = () => {
        return new Promise((resolve, reject) => {
            auth.onAuthStateChanged(user => {
                const firebaseUser = self.transformFirebaseUser(user)
                if (firebaseUser) {
                    return firebaseUser
                        .then((firebaseUser) => store.dispatch('auth/setCurrentUser', firebaseUser))
                        .then(() => {
                            self.started = true

                            const result = self.checkPendingRequest()
                            resolve(result)
                        })
                }

                store.dispatch('auth/setCurrentUser', null)
                self.started = true

                const result = self.checkPendingRequest()
                resolve(result)
            })
        })
    }

    self.transformFirebaseUser = (user) => {
        if (!user) return user

        return user.getIdTokenResult().then(userData => {
            return {
                displayName: user.displayName,
                email: user.email,
                emailVerified: user.emailVerified,
                photoURL: user.photoURL,
                providerData: user.providerData,
                providerId: user.providerId,
                refreshToken: user.refreshToken,
                uid: user.uid,
                isAdmin: user.isAdmin,
                claims: {
                    db: userData.claims.db,
                    level: userData.claims.level,
                },
            }
        })
    }

    self.checkRoute = (to, from, next) => {
        self.to = to
        self.from = from
        self.next = next

        NProgress.start()
        NProgress.set(0.1)

        if (!self.started) {
            return
        }

        self.checkPendingRequest()
    }

    self.checkPendingRequest = () => {
        const user = store.getters['auth/user']
        if (!user) {
            if (self.to.meta.public) {
                self.next()
                return { hasAccess: true, message: 'Public' }
            }

            if (self.from.path === '/signin') {
                self.next()
                return { hasAccess: true, message: 'Login page' }
            }

            self.next('/signin')
            return { hasAccess: false, message: 'Not logged' }
        }

        if (self.to.meta.layout === 'Session') {
            self.next('/happiness/dashboard')
            return { hasAccess: true, message: 'Redirect to dashboard' }
        }

        if (self.to.path !== '/profile' && user.claims && user.claims.level === 'user') {
            NProgress.done()
            self.next('/profile')
            return { hasAccess: false, message: 'User has only access to profile page' }
        }

        self.next()
        return { hasAccess: true, message: 'Has Access' }
    }
}

var acl = new Acl()

export default {
    install: (Vue, router) => {
        router.beforeEach(acl.checkRoute)

        Vue.prototype.$startAcl = acl.startAcl
    },
}
